<ng-container>
  <div mat-dialog-title>
    <span class="dialog-title-label" ></span>
    <button
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>
<div mat-dialog-content>
  <div class="list-numbered fixed-view">
    <ul>
      <li>
        <div>
          <span
            class="circle"
          >1</span>
        </div>
        <div>
          <span>text</span>
        </div>
      </li>
    </ul>
  </div>
</div>
<div mat-dialog-actions>
  <ng-container>
    <button
      class="btn btn-primary btn-mid btn-block btn-md-block-none"
      abButtonLoader
    >
      <span></span>
    </button>
  </ng-container>
  <ng-container>
    <button
      class="btn btn-link btn-with-icon btn-block btn-md-block-none">
      <span></span>
    </button>
  </ng-container>
</div>
